import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { editSubareaRequest } from '../requests/editSubareaRequest';
import { SubareaFormProps } from '../types/subarea.type';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useEditSubarea() {
	const navigate = useNavigate();

	const editSubarea = useMutation({
		mutationFn: async (data: SubareaFormProps) => {
			return editSubareaRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully edited!', type: 'success' });
			queryClient.invalidateQueries(['SUBAREA_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { editSubarea };
}
